module.exports = __webpack_public_path__ + "img/part2-icon1.61b1cc62.png";